const STORAGE_PREFIX = 'MS:';

export const DEFAULT_LOCALE = 'zh-CN';

export const storageKeys = {
  AUTH_TOKENS: `${STORAGE_PREFIX}authTokens`,
  LOCALE: `${STORAGE_PREFIX}locale`,
};



// WEBPACK FOOTER //
// /app/apps/ms/src/helpers/constants.js